export default {
  // Europe
  EU: 'EU',
  // North America
  NA: 'NA',
  // Asia Pacific
  AP: 'AP',
}
